<template>
  <v-container fluid class="page-wrap">
    <v-row>
         <v-col cols="12" class="text-center">
          <header-vue/>
        </v-col>

        <v-col
            md="12"
        >
                <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                    <v-card-title class="page-title-row">
                        <div>
                            <div class="text-overline accent--text font-weight-bold">ATTENDANCE</div>
                            <div class="text-h6 font-weight-bold primary--text">Teachers' Attendance GeoFencing</div>
                            <div class="text-body-2 grey--text">Set locations where teachers can clock in or out</div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="newGeoFence">

                          <v-col cols="12" v-if="lat && lng">
                            <v-card outlined class="rounded-lg overflow-hidden">
                                <iframe
                                  :src="mapUrl"
                                  width="100%"
                                  height="300"
                                  frameborder="0"
                                  allowfullscreen
                                  style="display: block;"
                                ></iframe>
                            </v-card>
                          </v-col>

                           <v-col cols="12" md="12">
                            <div v-if="lat && lng" class="text-caption grey--text mb-2">Latitude: {{ lat }} | Longitude: {{ lng }}</div>
                            <div class="gmap-autocomplete-wrap">
                                <v-icon color="grey darken-1" class="mr-2">mdi-map-search-outline</v-icon>
                                <GmapAutocomplete
                                    class="gmap-input"
                                    placeholder="Search school address"
                                    @place_changed="handlePlaceChange"
                                />
                            </div>
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="radius"
                              label="Geofence Radius (meters)"
                              type="number"
                              outlined
                              prepend-inner-icon="mdi-radius-outline"
                            />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="resumptionTime"
                                outlined
                                label="Select Resumption Time"
                                prepend-inner-icon="mdi-clock-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-time-picker
                              v-model="resumptionTime"
                              dense
                              @change="menu = false"
                              format="24hr"
                            ></v-time-picker>
                          </v-menu>
                          </v-col>

                          <v-col cols="12" md="12" v-if="lat && lng">
                            <v-btn @click="saveSettings" color="primary" rounded elevation="2" class="font-weight-bold text-none">
                                <v-icon left>mdi-content-save-outline</v-icon>
                                Save Settings
                            </v-btn>
                          </v-col>
                        </v-row>

                        <v-row v-if="records.length">
                            <v-col cols="12" class="mb-2">
                                <v-card outlined class="rounded-lg">
                                    <v-card-title class="text-subtitle-1 font-weight-bold primary--text">
                                        Geofence Locations
                                    </v-card-title>
                                    <v-data-table
                                        :headers="headers"
                                        :items="records"
                                        class="elevation-0"
                                        dense
                                        disable-pagination
                                        hide-default-footer
                                        sort-by="address"
                                    >
                                    </v-data-table>
                                </v-card>
                                <v-btn class="mt-4 font-weight-bold text-none" outlined rounded color="primary" @click="newGeoFence = true">
                                    <v-icon left>mdi-plus</v-icon>
                                    New GeoFence Location
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import HeaderVue from '../../components/Header.vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDnxP8xDXH3jch57ZXg9HchnaKb8s7GOYg', // replace with your actual key
    libraries: 'places' // important for autocomplete
  }
})

export default {
  data() {
    return {
        records: [],
        address: '',
        lat: null,
        lng: null,
        radius: 1000,
        resumptionTime: '08:00',
        menu: false,
        newGeoFence: false,
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : {},
        headers: [
            { text: 'Attendance Location', value: 'address', sortable: true },
            { text: 'Latitude', value: 'lat', sortable: true },
            { text: 'Longitude', value: 'lng', sortable: true },
            { text: 'Coverage (meters)', value: 'radius', sortable: true },
            { text: 'Resumption Time', value: 'resumption', sortable: true }
        ],
    };
  },
  components: {
        HeaderVue
    },
  computed: {
    mapUrl() {
      return `https://maps.google.com/maps?q=${this.lat},${this.lng}&z=16&output=embed`;
    }
  },
    mounted() {
       this.loadGeoFenceSettings()
    },
  methods: {

    handlePlaceChange(place) {
        this.address = place.formatted_address;
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
    },
    loadGeoFenceSettings() {
        axios.get(process.env.VUE_APP_BASEURL+'/attendances/geofence?school_id='+this.school.school_id,
        {
            headers:
                {
                    'Authorization': 'Bearer '+this.authToken,
                    'ngrok-skip-browser-warning': 'true'
                }
        })
        .then((res) => {
            this.records = res.data.records;
            this.records.length ? this.newGeoFence = false : this.newGeoFence = true
        })
        .catch(() => {
            this.$toast.error('APP is temporarily unavailable. Wait or Contact us!');
        })
    },
    saveSettings() {
        axios.post(process.env.VUE_APP_BASEURL+'/attendances/geofence?school_id='+this.school.school_id,{
            address: this.address,
            lat: this.lat,
            lng: this.lng,
            radius: this.radius,
            resumption: this.resumptionTime,
        },{
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'ngrok-skip-browser-warning': 'true'
                    }
            }).then(() => {
                this.$toast.success('Settings saved!');
                this.newGeoFence = false;
                this.loadGeoFenceSettings()
            })
            .catch((err)=> this.$toast.error(err.response.data.error ?? 'Failed to save attendance'))
    }
  }
}
</script>

<style scoped>
.gmap-autocomplete-wrap {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0 12px;
    height: 56px;
}
.gmap-input {
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    font-size: 1rem;
}
</style>
